import { pageHead } from "@/lib/routeHead";
import { createFileRoute } from "@tanstack/react-router";
import PerformanceTriagePage from "@/pages/admin/PerformanceTriagePage";

export const Route = createFileRoute("/_admin/admin/performance/triage")({
  head: () => pageHead("Admin · Performance · Triage", "AKIVA admin · performance · triage portal.", "/admin/performance/triage", true),
  component: PerformanceTriagePage,
});
